var __templateData = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (Array, complete, i18n, ids, image, letters, undefined, word) {
jade_mixins["image"] = jade_interp = function(imageUrl, klass){
var block = (this && this.block), attributes = (this && this.attributes) || {};
buf.push("<img" + (jade.attr("src", imageUrl, true, false)) + (jade.cls([klass], [true])) + "/>");
};
jade_mixins["image"] = jade_interp = function(imageUrl, klass){
var block = (this && this.block), attributes = (this && this.attributes) || {};
buf.push("<img" + (jade.attr("src", imageUrl, true, false)) + (jade.cls([klass], [true])) + "/>");
};
var klass = "jumble-answer-" + word.toLowerCase();
var multiline = /[\s-]/.test(word) && word.length > 7;
if (multiline) klass += " multiline";
buf.push("<div class=\"jumble-top\"><div class=\"jumble-top-content block-h-xl\"><div class=\"block-v-md\"><div class=\"jumble-image-container block-lt block-v-sm\">");
jade_mixins["image"](image,'jumble-image content-ver');
buf.push("<div class=\"jumble-masks\">");
// iterate (new Array(60))
;(function(){
  var $$obj = (new Array(60));
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var m = $$obj[$index];

buf.push("<div class=\"jumble-mask\"></div>");
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      var m = $$obj[$index];

buf.push("<div class=\"jumble-mask\"></div>");
    }

  }
}).call(this);

buf.push("</div></div></div><div" + (jade.cls(['jumble-answer','block-v-sm',klass], [null,null,true])) + ">");
// iterate word
;(function(){
  var $$obj = word;
  if ('number' == typeof $$obj.length) {

    for (var j = 0, $$l = $$obj.length; j < $$l; j++) {
      var letter = $$obj[j];

var i = complete.indexOf(letter);
if ( /[\s-]/.test(letter))
{
if ( multiline)
{
if ( letter != " ")
{
buf.push("<div class=\"droppy-complete\">" + (jade.escape(null == (jade_interp = letter) ? "" : jade_interp)) + "</div><div class=\"line-br-sm\"></div>");
}
else
{
buf.push("<br/>");
}
}
else
{
buf.push("<div class=\"droppy-complete\">&nbsp;</div>");
}
}
else if ( i > -1)
{
complete[i] = null;
buf.push("<div class=\"droppy-complete\"><div class=\"letter\">" + (jade.escape(null == (jade_interp = letter) ? "" : jade_interp)) + "</div></div>");
}
else
{
buf.push("<div" + (jade.attr("data-letter", letter, true, false)) + " class=\"droppy\"><div class=\"letter\">&nbsp;</div></div>");
}
    }

  } else {
    var $$l = 0;
    for (var j in $$obj) {
      $$l++;      var letter = $$obj[j];

var i = complete.indexOf(letter);
if ( /[\s-]/.test(letter))
{
if ( multiline)
{
if ( letter != " ")
{
buf.push("<div class=\"droppy-complete\">" + (jade.escape(null == (jade_interp = letter) ? "" : jade_interp)) + "</div><div class=\"line-br-sm\"></div>");
}
else
{
buf.push("<br/>");
}
}
else
{
buf.push("<div class=\"droppy-complete\">&nbsp;</div>");
}
}
else if ( i > -1)
{
complete[i] = null;
buf.push("<div class=\"droppy-complete\"><div class=\"letter\">" + (jade.escape(null == (jade_interp = letter) ? "" : jade_interp)) + "</div></div>");
}
else
{
buf.push("<div" + (jade.attr("data-letter", letter, true, false)) + " class=\"droppy\"><div class=\"letter\">&nbsp;</div></div>");
}
    }

  }
}).call(this);

buf.push("</div></div></div><div class=\"jumble-letters block-md clearfix\"><h4 class=\"jumble-prompt text-md-left block-sm\">" + (jade.escape((jade_interp = i18n("game-jumble.drag-letters")) == null ? '' : jade_interp)) + "</h4>");
// iterate letters
;(function(){
  var $$obj = letters;
  if ('number' == typeof $$obj.length) {

    for (var i = 0, $$l = $$obj.length; i < $$l; i++) {
      var letter = $$obj[i];

buf.push("<div" + (jade.attr("data-id", ids[i], true, false)) + (jade.attr("data-letter", letter, true, false)) + (jade.cls(['draggy','bold',"draggy-" + (i) + ""], [null,null,true])) + "><div class=\"letter\">" + (jade.escape(null == (jade_interp = letter) ? "" : jade_interp)) + "</div></div>");
    }

  } else {
    var $$l = 0;
    for (var i in $$obj) {
      $$l++;      var letter = $$obj[i];

buf.push("<div" + (jade.attr("data-id", ids[i], true, false)) + (jade.attr("data-letter", letter, true, false)) + (jade.cls(['draggy','bold',"draggy-" + (i) + ""], [null,null,true])) + "><div class=\"letter\">" + (jade.escape(null == (jade_interp = letter) ? "" : jade_interp)) + "</div></div>");
    }

  }
}).call(this);

buf.push("</div>");}.call(this,"Array" in locals_for_with?locals_for_with.Array:typeof Array!=="undefined"?Array:undefined,"complete" in locals_for_with?locals_for_with.complete:typeof complete!=="undefined"?complete:undefined,"i18n" in locals_for_with?locals_for_with.i18n:typeof i18n!=="undefined"?i18n:undefined,"ids" in locals_for_with?locals_for_with.ids:typeof ids!=="undefined"?ids:undefined,"image" in locals_for_with?locals_for_with.image:typeof image!=="undefined"?image:undefined,"letters" in locals_for_with?locals_for_with.letters:typeof letters!=="undefined"?letters:undefined,"undefined" in locals_for_with?locals_for_with.undefined:typeof undefined!=="undefined"?undefined:undefined,"word" in locals_for_with?locals_for_with.word:typeof word!=="undefined"?word:undefined));;return buf.join("");
};
if (typeof define === 'function' && define.amd) {
  define([], function() {
    return __templateData;
  });
} else if (typeof module === 'object' && module && module.exports) {
  module.exports = __templateData;
} else {
  __templateData;
}